import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { endpoints } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PersonCtx = createContext(null);
export const usePersonPanel = () => useContext(PersonCtx);

export function PersonPanelProvider({ children }) {
  const { user } = useAuth();
  const [openId, setOpenId] = useState(null);
  const [people, setPeople] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const pp = await endpoints.people();
      setPeople(pp);
      setLoaded(true);
    } catch (e) { setLoaded(true); }
  }, []);

  useEffect(() => {
    if (user && user !== false) refresh();
    else setPeople([]);
  }, [user, refresh]);

  const openPerson = useCallback((id) => { if (id) setOpenId(id); }, []);
  const closePerson = useCallback(() => setOpenId(null), []);

  const byId = useMemo(() => {
    const m = {};
    for (const p of people) m[p.id] = p;
    return m;
  }, [people]);

  const byName = useMemo(() => {
    const m = {};
    for (const p of people) if (p.name) m[p.name.toLowerCase()] = p;
    return m;
  }, [people]);

  const value = { openId, openPerson, closePerson, people, byId, byName, loaded, refresh };
  return <PersonCtx.Provider value={value}>{children}</PersonCtx.Provider>;
}
